import React, {useState, useCallback} from 'react';
import { useForm } from 'react-hook-form';
import { useMutation, useQuery } from '@apollo/client';
import DataState from 'app/src/components/DataState';
import Input from 'app/src/elements/inputs';
import { Button, ButtonGroup } from 'app/src/elements/buttons';
import { View } from 'react-native';
import { CREATE_BUYER_SALE, SELECTS } from './queries';
import { ButtonContainer } from '../../../elements';
import moment from 'moment';

const NewSale = ({sale, setShowModal, refetch}) => {
  const [submitting, setSubmitting] = useState();

  const { loading, error, data, refetch: selectRefetch } = useQuery(
    SELECTS, { variables: { saleId: sale.id, forBuyerSale: true } }
  );

  const [createBuyerSale] = useMutation(CREATE_BUYER_SALE, {
    onCompleted: () => {
      if(refetch) {
        refetch();
      }
      if(selectRefetch) {
        selectRefetch();
      }
      setShowModal(false);
    }
  });

  const onSubmit = useCallback(input => {
    input['paddleNumber'] = parseInt(input['paddleNumber']);
    setSubmitting(true);
    createBuyerSale({ variables: input });
  });

  const { control, handleSubmit, register, formState: { errors } } = useForm({
    defaultValues: {
      saleId: sale.id,
      buyerId: '',
      paddleServiceId: '',
      paddleNumber: ''
    }
  });

  if(loading) {
    return <DataState.Loading />;
  }

  return (
    <View>
      {submitting ?
        <DataState.Loading /> :
        <View>
          <Input.Picker
            label="Buyer:"
            name="buyerId"
            options={data?.buyerSelectOptions?.map(buyer => {
              return { value: buyer.id, label: buyer.name }
            })}
            control={control}
            errors={errors}
            {...register("buyerId", {
              required: "Required"
            })}
          />
          <Input.Picker
            label="Paddle Service:"
            name="paddleServiceId"
            options={data?.paddleServices?.map(paddleService => {
              return { value: paddleService.id, label: paddleService.code }
            })}
            control={control}
            errors={errors}
            {...register("paddleServiceId", {
              required: "Required"
            })}
          />
          <Input.Number
            label="Paddle Number:"
            name="paddleNumber"
            control={control}
            errors={errors}
            {...register("paddleNumber", {
              required: "Required",
              pattern: {
                value: /^[0-9]+$/,
                message: 'Please enter a number',
              },
            })}
          />

          <ButtonContainer>
            <ButtonGroup>
              <Button label="Create Sale Buyer" onPress={handleSubmit(onSubmit)} />
            </ButtonGroup>
          </ButtonContainer>
        </View>
      }
    </View>
  )
}

export default NewSale;